import { Form, Formik } from 'formik';
import { useRouter } from 'next/router';
import { useRef } from 'react';
import { AmountInputField } from '~/components/amount-input';
import { Button } from '~/components/button';
import { ButtonGroup } from '~/components/button-group';
import { CheckboxField } from '~/components/checkbox';
import { Grid } from '~/components/layout';

import { useForm, Values } from './hooks/use-form'
import { Wrapper  } from './style'

type Props = {
  color: string
  slug: string
}

// TODO: investigate - reuse?
const getTiers = (queryTiers: string | string[] | undefined): number[] => {
  const defaultTiers = [25, 50, 100, 200]
  if (typeof queryTiers === 'string') {
    const tiers = queryTiers
      .split(',')
      .map(tier => Number(tier))
      .filter(Boolean)

    return tiers.length === 0 ? defaultTiers : tiers
  }

  return defaultTiers
}

export const EmbeddableDonationForm = ({ color, slug }: Props) => {
  console.log('here we are???')


  const { query } = useRouter()
  const inputRef = useRef<HTMLInputElement>(null)

  const handleSubmit = (values: Values) => {
    const redirectUrl = `https://kindest.com/${slug}?amount=${values.amount}&monthly=${values.monthly}`
    window.open(redirectUrl)
  }

  const { initialValues, schema } = useForm()
  const tiers = getTiers(query.tiers)

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={schema}
      validateOnBlur={false}
    >
      {({ setFieldValue, setFieldTouched }) => (
        <Wrapper color={color}>
          <Form>
            <Grid gridRowGap={20}>
              <AmountInputField ref={inputRef} name="amount" autoFocus />
              <ButtonGroup>
                {tiers.map((tier, index) => (
                  <Button
                    key={`${tier}-${index}`}
                    variant="outline"
                    onClick={() => {
                      setFieldTouched('amount', false)
                      setFieldValue('amount', tier * 100)
                    }}
                  >
                    ${tier}
                  </Button>
                ))}
                <Button
                  variant="outline"
                  onClick={() => {
                    setFieldTouched('amount', false)
                    setFieldValue('amount', 0)
                    inputRef.current?.focus()
                  }}
                >
                  Custom
                </Button>
              </ButtonGroup>
              <CheckboxField
                name="monthly"
                label="Make your gift go further - give monthly"
              />
              <Button type="submit" width="100%" size="large">
                Donate
              </Button>
            </Grid>
          </Form>
        </Wrapper>
      )}
    </Formik>
  )
}